import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ReactComponent as LogoIcon } from "../../assets/logo/logo-centralis-gris.svg";
import Button from '../../composants/Button/Button';
import './VerifyEmailSend.css';

const VerifyEmailSend: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setIsLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/email/sendverify`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ email: email.toLowerCase() }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message || 'Email de vérification envoyé avec succès !');
            } else {
                setError(data.message || 'Une erreur est survenue lors de l\'envoi de l\'email');
            }
        } catch (error) {
            console.error('Erreur lors de l\'envoi:', error);
            setError('Une erreur de connexion est survenue');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="verify-email-send-container">
            <div className="verify-email-send-card">
                <div className="logo-container">
                    <LogoIcon className="logo" />
                </div>
                <h1>Vérifier votre email</h1>
                <p className="description">
                    Entrez votre adresse email pour recevoir un lien de vérification.
                </p>

                {error && <div className="error-message">{error}</div>}
                {message && <div className="success-message">{message}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Adresse email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="votre.email@exemple.com"
                            required
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="primary"
                        value={isLoading ? "Envoi en cours..." : "Envoyer l'email de vérification"}
                        size="medium"
                        disabled={isLoading}
                    />
                </form>

                <div className="verify-email-send-footer">
                    <p className="back-to-login">
                        <Link to="/login">← Retour à la connexion</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailSend;